import React, { useEffect, useState } from "react";
import { Table, Button, Space, Tag, Tooltip, Row, Col, Spin } from "antd";
import {
    ReloadOutlined,
    HistoryOutlined,
    CheckCircleOutlined,
    PlusOutlined,
    EditOutlined
} from "@ant-design/icons";
import { getProspections } from "../../api/prospections";
import ModalRelance from "../../composants/commerciale/ModalRelance";
import ModalChangeStatus from "../../composants/commerciale/ModalChangeStatus";
import ModalHistorique from "../../composants/commerciale/ModalHistorique";
import ModalProspectionForm from "../../composants/commerciale/ModalProspectionForm"
import { get_ListeClients } from "../../api/clients";
import { get_ListeRegion } from "../../api/region";
import { get_all_agences, get_all_users } from "../../api/users";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";
// import XLSX from 'xlsx-style';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const statusColor = {
    NOUVEAU: "blue",
    EN_ATTENTE: "orange",
    RELANCE: "gold",
    EN_COURS: "cyan",
    CONCLU: "green",
    PERDU: "red",
};


export default function ProspectionsList() {
    const [listeClients, setListeClients] = useState([]);
    const [listeRegion, setListeRegion] = useState([]);
    const [listeUsers, setlisteUsers] = useState([]);
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(null);
    const [openRelance, setOpenRelance] = useState(false);
    const [openHistorique, setOpenHistorique] = useState(false);
    const [openStatus, setOpenStatus] = useState(false);
    const [openCreate, setOpenCreate] = useState(false);
    const loadData = async () => {
        setLoading(true)
        const res = await getProspections();
        const res_client = await get_ListeClients()
        const res_region = await get_ListeRegion()
        const res_user = await get_all_users()
        setData(res.data);
        setListeClients(res_client.data)
        setListeRegion(res_region.data)
        setlisteUsers(res_user.data)
        setLoading(false)
    };
    const [filteredData, setFilteredData] = useState([]);
    const [listAgence, setListeAgence] = useState([])

    useEffect(() => {
        fetchListeAgence()
        loadData();
    }, []);

    const fetchListeAgence = async () => {
        const res = await get_all_agences();
        if (res.status === "success") {
            setListeAgence(res.data);
        }
    };


    const columns = [
        {
            title: "Id",
            key: "id",
            dataIndex: "id",
            align: "center",
        },
        {
            title: "Service",
            key: "service",
            dataIndex: "service",
            align: "center",

            filters: [
                { text: "Transport", value: "transport" },
                { text: "Transit", value: "transit" },
                { text: "Transit + Transport", value: "transit_transport" },
            ],

            onFilter: (value, record) => record.service === value,

            render: (service) => {
                const color =
                    service === "transport"
                        ? "blue"
                        : service === "transit"
                            ? "green"
                            : "purple";

                return <Tag color={color}>{service}</Tag>;
            },
        },

        {
            title: "Client / Marchandise",
            key: "client",
            render: (_, r) => {
                const client = listeClients.find(c => c.id === r.client_id);
                return (
                    <>
                        <strong>{client ? client.nom : r.prospect_nom || "—"}</strong>
                        <br />
                        <span style={{ color: "#888" }}>{r.marchandise || "-"}</span>
                    </>
                );
            },
            filters: listeClients.map(c => ({ text: c.nom, value: c.id })),
            onFilter: (value, record) => record.client_id === value,
        },

        {
            title: "Trajet",
            key: "trajet",
            render: (_, r) => {
                const regionDepart = listeRegion.find(reg => reg.id === r.region_depart);
                const regionArrive = listeRegion.find(reg => reg.id === r.region_arrive);
                return (
                    <>
                        {regionDepart ? regionDepart.nom : "?"} ➜ {regionArrive ? regionArrive.nom : "?"}
                        <br />
                        <span style={{ fontSize: 12, color: "#888" }}>
                            {new Date(r.date_depart).toLocaleString() || "?"} → {new Date(r.date_arrive).toLocaleString() || "?"}
                        </span>
                    </>
                );
            },
            filters: listeRegion.map(r => ({ text: r.nom, value: r.id })),
            onFilter: (value, record) =>
                record.region_depart === value || record.region_arrive === value,
        },
        {
            title: "Commerciale",
            dataIndex: "user_id",
            key: "user_id",
            align: "center",

            // 🔹 Filtre par agence
            filters: listAgence.map(a => ({
                text: a.nom,
                value: `agence_${a.id}`, // on marque que c’est un filtre agence
            })),

            // 🔹 OnFilter pour gérer filtre combiné
            onFilter: (value, record) => {
                const user = listeUsers.find(u => u.id === record.user_id);
                if (!user) return false;

                // Filtre par agence
                if (value.startsWith("agence_")) {
                    const agenceId = Number(value.split("_")[1]);
                    return user.agence_id === agenceId;
                }

                // Filtre par utilisateur
                return user.id === value;
            },

            // 🔹 Affichage + filtres utilisateurs (dynamique selon l’agence sélectionnée)
            render: (_, record) => {
                const user = listeUsers.find(u => u.id === record.user_id);
                if (!user) return "—";

                const agence = listAgence.find(a => a.id === user.agence_id);
                const fullName = `${user.prenom} ${user.nom}`;

                // Couleur du tag selon fonction
                const fonctionTagColor = user.fonction_id === 1 ? "blue" : "green";

                return (
                    <Space direction="vertical" size={2}>
                        <Tag color={fonctionTagColor}>{fullName}</Tag>
                        {agence && <Tag color="orange">{agence.nom}</Tag>}
                    </Space>
                );
            },
        },
        {
            title: "Volume",
            key: "volume",
            render: (_, r) => (
                <>
                    {r.poids ? `${r.poids} kg` : "-"}
                    <br />
                    <span style={{ fontSize: 12, color: "#888" }}>
                        {r.distance ? `${r.distance} km` : "-"}
                    </span>
                </>
            ),
            sorter: (a, b) => (a.poids || 0) - (b.poids || 0),
        },
        {
            title: "TC",
            key: "tc",
            align: "center",
            render: (_, r) =>
                r.nb_tc ? (
                    <Tag color="geekblue">
                        {r.nb_tc} × {r.type_tc}
                    </Tag>
                ) : (
                    "-"
                ),
            sorter: (a, b) => (a.nb_tc || 0) - (b.nb_tc || 0),
        },
        {
            title: "Montant (AR)",
            dataIndex: "montant_estime",
            align: "right",
            render: (v) => (v ? <strong>{Number(v).toLocaleString()}</strong> : "-"),
            sorter: (a, b) => (a.montant_estime || 0) - (b.montant_estime || 0),
        },
        {
            title: "Priorité",
            dataIndex: "priorite",
            align: "center",
            render: (p) => {
                const color = p === "HAUTE" ? "red" : p === "MOYENNE" ? "orange" : "blue";
                return <Tag color={color}>{p}</Tag>;
            },
            filters: [
                { text: "HAUTE", value: "HAUTE" },
                { text: "MOYENNE", value: "MOYENNE" },
                { text: "BASSE", value: "BASSE" },
            ],
            onFilter: (value, record) => record.priorite === value,
        },
        {
            title: "Statut",
            dataIndex: "status",
            align: "center",
            render: (s) => <Tag color={statusColor[s]}>{s}</Tag>,
            filters: Object.keys(statusColor).map(s => ({ text: s, value: s })),
            onFilter: (value, record) => record.status === value,
        },
        {
            title: "Actions",
            key: "actions",
            fixed: "right",
            render: (_, record) => (
                <Space>
                    <Tooltip title="editer">
                        {
                            hasPermission(getPermissionsFromToken(), "PROSPECTION_EDIT") && <Button
                                icon={<EditOutlined />}
                                onClick={() => {
                                    console.log(record);
                                    setSelected(record);
                                    setOpenCreate(true);
                                }}
                            />
                        }
                    </Tooltip>

                    <Tooltip title="Changer statut">
                        {
                            hasPermission(getPermissionsFromToken(), "PROSPECTION_CHANGE_STATUS") && <Button
                                icon={<CheckCircleOutlined />}
                                onClick={() => {
                                    setSelected(record);
                                    setOpenStatus(true);
                                }}
                            />
                        }
                    </Tooltip>

                    <Tooltip title="Créer relance">
                        {
                            hasPermission(getPermissionsFromToken(), "PROSPECTION_RELANCE") && <Button
                                icon={<ReloadOutlined />}
                                onClick={() => {
                                    setSelected(record);
                                    setOpenRelance(true);
                                }}
                            />
                        }

                    </Tooltip>

                    <Tooltip title="Historique">
                        {
                            hasPermission(getPermissionsFromToken(), "PROSPECTION_SHOW_HISTORIQUE") && <Button
                                icon={<HistoryOutlined />}
                                onClick={() => {
                                    setSelected(record);
                                    setOpenHistorique(true);
                                }}
                            />
                        }

                    </Tooltip>
                </Space>
            ),
        },
    ];

    const handleTableChange = (pagination, filters, sorter, extra) => {
        // extra.currentDataSource = données visibles après filtres & tri
        setFilteredData(extra.currentDataSource);
    };

    // const exportExcel = () => {
    //     const exportData = (filteredData.length ? filteredData : data).map(r => {
    //         const client = listeClients.find(c => c.id === r.client_id);
    //         console.log(client);
    //         const regionDepart = listeRegion.find(reg => reg.id === r.region_depart);
    //         const regionArrive = listeRegion.find(reg => reg.id === r.region_arrive);
    //         const user = listeUsers.find(u => u.id === r.user_id);
    //         console.log(r);
    //         return {
    //             ID: r.id,
    //             Client: client ? client.nom : r.prospect_nom,
    //             "Domaine d'activité": client.description,
    //             "Contact": client.telephone,
    //             "Adresse": client.addresse,
    //             "Interlocuteur": r.interlocuteur_nom,
    //             "Notes": r.description,
    //             Marchandise: r.marchandise,
    //             "Région départ": regionDepart?.nom,
    //             "Région arrivée": regionArrive?.nom,
    //             "Date départ": new Date(r.date_depart).toLocaleString(),
    //             "Date arrivée": new Date(r.date_arrive).toLocaleString(),
    //             Commercial: user?.prenom,
    //             Poids: r.poids,
    //             Distance: r.distance,
    //             "Nb TC": r.nb_tc,
    //             "Type TC": r.type_tc,
    //             Montant: r.montant_estime,
    //             Priorité: r.priorite,
    //             Statut: r.status,
    //         };
    //     });
    //     const worksheet = XLSX.utils.json_to_sheet(exportData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Prospections");
    //     const excelBuffer = XLSX.write(workbook, {
    //         bookType: "xlsx",
    //         type: "array",
    //     });
    //     const blob = new Blob([excelBuffer], {
    //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });
    //     saveAs(blob, `prospections_${new Date().toISOString().slice(0, 10)}.xlsx`);
    // };

    // const exportExcel = (dateFrom = null, dateTo = null) => {
    //     const baseData = filteredData.length ? filteredData : data;

    //     // Filtre optionnel par date
    //     const filtered = baseData.filter(r => {
    //         if (!dateFrom && !dateTo) return true;
    //         const depart = new Date(r.date_depart);
    //         if (dateFrom && depart < new Date(dateFrom)) return false;
    //         if (dateTo && depart > new Date(dateTo)) return false;
    //         return true;
    //     });

    //     const exportData = filtered.map(r => {
    //         const client = listeClients.find(c => c.id === r.client_id);
    //         const regionDepart = listeRegion.find(reg => reg.id === r.region_depart);
    //         const regionArrive = listeRegion.find(reg => reg.id === r.region_arrive);
    //         const user = listeUsers.find(u => u.id === r.user_id);
    //         return {
    //             ID: r.id,
    //             Client: client ? client.nom : r.prospect_nom,
    //             "Domaine d'activité": client?.description ?? "",
    //             Contact: client?.telephone ?? "",
    //             Adresse: client?.addresse ?? "",
    //             Interlocuteur: r.interlocuteur_nom,
    //             Notes: r.description,
    //             Marchandise: r.marchandise,
    //             "Région départ": regionDepart?.nom ?? "",
    //             "Région arrivée": regionArrive?.nom ?? "",
    //             "Date départ": r.date_depart ? new Date(r.date_depart).toLocaleDateString("fr-FR") : "",
    //             "Date arrivée": r.date_arrive ? new Date(r.date_arrive).toLocaleDateString("fr-FR") : "",
    //             Commercial: user?.prenom ?? "",
    //             Poids: r.poids,
    //             Distance: r.distance,
    //             "Nb TC": r.nb_tc,
    //             "Type TC": r.type_tc,
    //             Montant: r.montant_estime,
    //             Priorité: r.priorite,
    //             Statut: r.status,
    //         };
    //     });

    //     const wb = XLSX.utils.book_new();

    //     // ─── Feuille principale ───────────────────────────────────────────────
    //     const ws = XLSX.utils.aoa_to_sheet([]);

    //     // Titre principal (ligne 1)
    //     XLSX.utils.sheet_add_aoa(ws, [
    //         ["RAPPORT DE PROSPECTIONS"],
    //         [`Exporté le ${new Date().toLocaleDateString("fr-FR")} · ${filtered.length} enregistrement(s)${dateFrom || dateTo ? ` · Période : ${dateFrom ?? "—"} → ${dateTo ?? "—"}` : ""}`],
    //         [], // ligne vide
    //     ], { origin: "A1" });

    //     // Headers (ligne 4)
    //     const headers = Object.keys(exportData[0] || {});
    //     XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A4" });

    //     // Données (à partir de ligne 5)
    //     XLSX.utils.sheet_add_json(ws, exportData, { origin: "A5", skipHeader: true });

    //     // ── Styles via !cols (largeurs) ──────────────────────────────────────
    //     ws["!cols"] = [
    //         { wch: 6 },   // ID
    //         { wch: 24 },  // Client
    //         { wch: 22 },  // Domaine
    //         { wch: 16 },  // Contact
    //         { wch: 26 },  // Adresse
    //         { wch: 18 },  // Interlocuteur
    //         { wch: 30 },  // Notes
    //         { wch: 18 },  // Marchandise
    //         { wch: 16 },  // Région départ
    //         { wch: 16 },  // Région arrivée
    //         { wch: 14 },  // Date départ
    //         { wch: 14 },  // Date arrivée
    //         { wch: 14 },  // Commercial
    //         { wch: 8 },   // Poids
    //         { wch: 10 },  // Distance
    //         { wch: 7 },   // Nb TC
    //         { wch: 10 },  // Type TC
    //         { wch: 14 },  // Montant
    //         { wch: 10 },  // Priorité
    //         { wch: 12 },  // Statut
    //     ];

    //     // ── Styles cellules (nécessite xlsx-style ou mise en forme manuelle) ──
    //     // Fusion titre sur toute la largeur
    //     ws["!merges"] = [
    //         { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
    //         { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
    //     ];

    //     // Appliquer styles avec xlsx-style (si disponible) ou fallback natif SheetJS
    //     const applyStyle = (cellRef, style) => {
    //         if (!ws[cellRef]) ws[cellRef] = { v: "", t: "s" };
    //         ws[cellRef].s = style;
    //     };

    //     const COLORS = {
    //         headerBg: "1E3A5F",       // bleu marine foncé
    //         headerFg: "FFFFFF",
    //         titleBg: "0F2340",
    //         subtitleFg: "A0B4CC",
    //         rowEven: "F0F4F9",
    //         rowOdd: "FFFFFF",
    //         accent: "2196F3",
    //         border: "C5D4E8",
    //     };

    //     const headerStyle = {
    //         font: { bold: true, color: { rgb: COLORS.headerFg }, name: "Arial", sz: 10 },
    //         fill: { fgColor: { rgb: COLORS.headerBg }, patternType: "solid" },
    //         alignment: { horizontal: "center", vertical: "center", wrapText: true },
    //         border: {
    //             top: { style: "thin", color: { rgb: COLORS.border } },
    //             bottom: { style: "medium", color: { rgb: COLORS.accent } },
    //             left: { style: "thin", color: { rgb: COLORS.border } },
    //             right: { style: "thin", color: { rgb: COLORS.border } },
    //         },
    //     };

    //     const titleStyle = {
    //         font: { bold: true, color: { rgb: COLORS.headerFg }, name: "Arial", sz: 16 },
    //         fill: { fgColor: { rgb: COLORS.titleBg }, patternType: "solid" },
    //         alignment: { horizontal: "center", vertical: "center" },
    //     };

    //     const subtitleStyle = {
    //         font: { color: { rgb: COLORS.subtitleFg }, name: "Arial", sz: 10, italic: true },
    //         fill: { fgColor: { rgb: COLORS.titleBg }, patternType: "solid" },
    //         alignment: { horizontal: "center", vertical: "center" },
    //     };

    //     // Style titre
    //     applyStyle("A1", titleStyle);
    //     applyStyle("A2", subtitleStyle);

    //     // Style headers
    //     headers.forEach((_, i) => {
    //         const col = XLSX.utils.encode_col(i);
    //         applyStyle(`${col}4`, headerStyle);
    //     });

    //     // Style lignes de données (alternées)
    //     exportData.forEach((_, rowIdx) => {
    //         const excelRow = rowIdx + 5; // commence à la ligne 5
    //         const isEven = rowIdx % 2 === 0;
    //         const rowFill = {
    //             fgColor: { rgb: isEven ? COLORS.rowEven : COLORS.rowOdd },
    //             patternType: "solid",
    //         };
    //         const borderStyle = {
    //             bottom: { style: "thin", color: { rgb: COLORS.border } },
    //             left: { style: "thin", color: { rgb: COLORS.border } },
    //             right: { style: "thin", color: { rgb: COLORS.border } },
    //         };

    //         headers.forEach((_, colIdx) => {
    //             const cellRef = XLSX.utils.encode_cell({ r: excelRow - 1, c: colIdx });
    //             if (!ws[cellRef]) ws[cellRef] = { v: "", t: "s" };
    //             ws[cellRef].s = {
    //                 font: { name: "Arial", sz: 9, color: { rgb: "1A1A2E" } },
    //                 fill: rowFill,
    //                 border: borderStyle,
    //                 alignment: { vertical: "center", wrapText: false },
    //             };
    //         });
    //     });

    //     // Hauteur des lignes
    //     ws["!rows"] = [
    //         { hpt: 36 }, // Titre
    //         { hpt: 20 }, // Sous-titre
    //         { hpt: 8 },  // Ligne vide
    //         { hpt: 30 }, // Headers
    //         ...exportData.map(() => ({ hpt: 20 })),
    //     ];

    //     XLSX.utils.book_append_sheet(wb, ws, "Prospections");

    //     // ─── Feuille Résumé ───────────────────────────────────────────────────
    //     const wsStats = XLSX.utils.aoa_to_sheet([
    //         ["RÉSUMÉ STATISTIQUE"],
    //         [],
    //         ["Indicateur", "Valeur"],
    //         ["Total prospections", filtered.length],
    //         ["Montant total estimé", exportData.reduce((s, r) => s + (Number(r.Montant) || 0), 0)],
    //         ["Poids total", exportData.reduce((s, r) => s + (Number(r.Poids) || 0), 0)],
    //         ["Distance totale", exportData.reduce((s, r) => s + (Number(r.Distance) || 0), 0)],
    //         [],
    //         ["Répartition par statut"],
    //         ...Object.entries(
    //             filtered.reduce((acc, r) => {
    //                 acc[r.status] = (acc[r.status] || 0) + 1;
    //                 return acc;
    //             }, {})
    //         ).map(([k, v]) => [k, v]),
    //         [],
    //         ["Répartition par commercial"],
    //         ...Object.entries(
    //             filtered.reduce((acc, r) => {
    //                 const user = listeUsers.find(u => u.id === r.user_id);
    //                 const name = user?.prenom ?? "Inconnu";
    //                 acc[name] = (acc[name] || 0) + 1;
    //                 return acc;
    //             }, {})
    //         ).map(([k, v]) => [k, v]),
    //     ]);

    //     wsStats["!cols"] = [{ wch: 28 }, { wch: 18 }];
    //     wsStats["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];

    //     XLSX.utils.book_append_sheet(wb, wsStats, "Résumé");

    //     // Export
    //     const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellStyles: true });
    //     const blob = new Blob([buffer], {
    //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });
    //     saveAs(blob, `prospections_${new Date().toISOString().slice(0, 10)}.xlsx`);
    // };

    const exportExcel = () => {
    const exportData = (filteredData.length ? filteredData : data).map(r => {
        const client = listeClients.find(c => c.id === r.client_id);
        const regionDepart = listeRegion.find(reg => reg.id === r.region_depart);
        const regionArrive = listeRegion.find(reg => reg.id === r.region_arrive);
        const user = listeUsers.find(u => u.id === r.user_id);
        return {
            ID: r.id,
            Client: client ? client.nom : r.prospect_nom,
            "Domaine d'activité": client?.description ?? "",
            Contact: client?.telephone ?? "",
            Adresse: client?.addresse ?? "",
            Interlocuteur: r.interlocuteur_nom,
            Notes: r.description,
            Marchandise: r.marchandise,
            "Région départ": regionDepart?.nom ?? "",
            "Région arrivée": regionArrive?.nom ?? "",
            "Date départ": r.date_depart ? new Date(r.date_depart).toLocaleDateString("fr-FR") : "",
            "Date arrivée": r.date_arrive ? new Date(r.date_arrive).toLocaleDateString("fr-FR") : "",
            Commercial: user?.prenom ?? "",
            Poids: r.poids,
            Distance: r.distance,
            "Nb TC": r.nb_tc,
            "Type TC": r.type_tc,
            Montant: r.montant_estime,
            Priorité: r.priorite,
            Statut: r.status,
        };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const headers = Object.keys(exportData[0] || {});

    // Titre + sous-titre
    XLSX.utils.sheet_add_aoa(ws, [
        ["RAPPORT DE PROSPECTIONS"],
        [`Exporté le ${new Date().toLocaleDateString("fr-FR")} · ${exportData.length} enregistrement(s)`],
        [],
        headers,
    ], { origin: "A1" });

    XLSX.utils.sheet_add_json(ws, exportData, { origin: "A5", skipHeader: true });

    ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
    ];

    ws["!cols"] = [
        { wch: 6 }, { wch: 24 }, { wch: 22 }, { wch: 16 }, { wch: 26 },
        { wch: 18 }, { wch: 30 }, { wch: 18 }, { wch: 16 }, { wch: 16 },
        { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 8 }, { wch: 10 },
        { wch: 7 }, { wch: 10 }, { wch: 14 }, { wch: 10 }, { wch: 12 },
    ];

    ws["!rows"] = [
        { hpt: 36 },
        { hpt: 20 },
        { hpt: 8 },
        { hpt: 30 },
        ...exportData.map(() => ({ hpt: 20 })),
    ];

    const applyStyle = (cellRef, style) => {
        if (!ws[cellRef]) ws[cellRef] = { v: "", t: "s" };
        ws[cellRef].s = style;
    };

    // Titre
    applyStyle("A1", {
        font: { bold: true, color: { rgb: "FFFFFF" }, name: "Arial", sz: 16 },
        fill: { fgColor: { rgb: "0F2340" }, patternType: "solid" },
        alignment: { horizontal: "center", vertical: "center" },
    });

    // Sous-titre
    applyStyle("A2", {
        font: { color: { rgb: "A0B4CC" }, name: "Arial", sz: 10, italic: true },
        fill: { fgColor: { rgb: "0F2340" }, patternType: "solid" },
        alignment: { horizontal: "center", vertical: "center" },
    });

    // Headers
    headers.forEach((_, i) => {
        const cellRef = XLSX.utils.encode_cell({ r: 3, c: i });
        applyStyle(cellRef, {
            font: { bold: true, color: { rgb: "FFFFFF" }, name: "Arial", sz: 10 },
            fill: { fgColor: { rgb: "1E3A5F" }, patternType: "solid" },
            alignment: { horizontal: "center", vertical: "center", wrapText: true },
            border: {
                top:    { style: "thin", color: { rgb: "C5D4E8" } },
                bottom: { style: "medium", color: { rgb: "2196F3" } },
                left:   { style: "thin", color: { rgb: "C5D4E8" } },
                right:  { style: "thin", color: { rgb: "C5D4E8" } },
            },
        });
    });

    // Lignes de données alternées
    exportData.forEach((_, rowIdx) => {
        const isEven = rowIdx % 2 === 0;
        headers.forEach((_, colIdx) => {
            const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 4, c: colIdx });
            if (!ws[cellRef]) ws[cellRef] = { v: "", t: "s" };
            ws[cellRef].s = {
                font: { name: "Arial", sz: 9, color: { rgb: "1A1A2E" } },
                fill: { fgColor: { rgb: isEven ? "F0F4F9" : "FFFFFF" }, patternType: "solid" },
                border: {
                    bottom: { style: "thin", color: { rgb: "C5D4E8" } },
                    left:   { style: "thin", color: { rgb: "C5D4E8" } },
                    right:  { style: "thin", color: { rgb: "C5D4E8" } },
                },
                alignment: { vertical: "center" },
            };
        });
    });

    XLSX.utils.book_append_sheet(wb, ws, "Prospections");

    const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellStyles: true });
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `prospections_${new Date().toISOString().slice(0, 10)}.xlsx`);
};



    return (
        <div>
            <Row style={{ marginBottom: 16 }}>
                <Col>
                    <Space>
                        {
                            hasPermission(getPermissionsFromToken(), "VIEW_PROSPECTION_ADD") &&
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setOpenCreate(true)}
                            >
                                Nouvelle prospection
                            </Button>
                        }

                        {
                            hasPermission(getPermissionsFromToken(), "PROSPECTION_EXPORT") && <Button
                                style={{
                                    backgroundColor: "#52c41a",
                                    borderColor: "#52c41a",
                                    color: "#fff",
                                }}
                                onClick={exportExcel}
                            >
                                Exporter Excel
                            </Button>
                        }



                    </Space>
                </Col>
            </Row>

            <div style={{ height: '70vh', overflowY: 'auto' }}>
                <Spin spinning={loading}>
                    <Table
                        rowKey="id"
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            pageSize: 7,
                            position: ["bottomCenter"],
                            className: "custom-pagination",
                            style: {
                                display: "flex",
                                justifyContent: "center",
                                marginTop: 12,
                            },
                            itemRender: (page, type, originalElement) => {
                                if (type === "page") {
                                    return (
                                        <div
                                            style={{
                                                borderRadius: "50%",
                                                minWidth: 32,
                                                height: 32,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                border: "1px solid #d9d9d9",
                                            }}
                                        >
                                            {page}
                                        </div>
                                    );
                                }
                                return originalElement;
                            },
                        }}
                        onChange={handleTableChange}
                    />
                </Spin>
            </div>


            <ModalRelance
                open={openRelance}
                prospection={selected}
                onClose={() => setOpenRelance(false)}
                onSuccess={loadData}
            />

            <ModalHistorique
                open={openHistorique}
                prospection={selected}
                liste_users={listeUsers}
                onClose={() => setOpenHistorique(false)}
            />

            <ModalChangeStatus
                open={openStatus}
                prospection={selected}
                onClose={() => setOpenStatus(false)}
                onSuccess={loadData}
            />

            <ModalProspectionForm
                open={openCreate}
                onClose={() => {
                    setOpenCreate(false)
                    setSelected(null)
                }}
                onSuccess={() => {
                    setOpenCreate(false);
                    loadData();
                }}
                prospectionToEdit={selected}
            />


        </div>
    );
}
